<app-pt-navbar></app-pt-navbar>
<main class="auth-page bg-body text-body">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-5">
        <form
          class="login-card card bg-body border shadow"
          [formGroup]="form"
          (ngSubmit)="submit()"
        >
          <div class="card-header bg-primary text-white">
            <h1 class="h5 mb-0"><i class="bi bi-box-arrow-in-right me-2"></i>Iniciar sesión</h1>
          </div>
          <div class="card-body">
            <label class="form-label" for="fd_login">Usuario</label>
            <div class="input-group">
              <span class="input-group-text bg-body-tertiary"><i class="bi bi-person"></i></span
              ><input
                id="fd_login"
                class="form-control bg-body text-body"
                formControlName="fd_login"
                autocomplete="username"
                [readOnly]="loading()"
              />
            </div>
            @if (form.controls.fd_login.touched && form.controls.fd_login.invalid) {
              <small>El usuario es obligatorio.</small>
            }
            <label class="form-label mt-3" for="fd_passd">Contraseña</label>
            <div class="input-group">
              <span class="input-group-text bg-body-tertiary"><i class="bi bi-lock"></i></span
              ><input
                id="fd_passd"
                class="form-control bg-body text-body"
                type="password"
                formControlName="fd_passd"
                autocomplete="current-password"
                [readOnly]="loading()"
              />
            </div>
            @if (form.controls.fd_passd.touched && form.controls.fd_passd.invalid) {
              <small>La contraseña es obligatoria.</small>
            }
            <button class="btn btn-primary w-100 mt-4" type="submit" [disabled]="loading()">
              <i class="bi bi-box-arrow-in-right me-2"></i
              >{{ loading() ? 'Ingresando…' : 'Ingresar' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>
<app-pt-footer></app-pt-footer>
